import { getState } from 'lib/store'
import type { LogEventCount, TimeInterval } from 'types/search/chart'

// Default empty array (reused to avoid creating new objects)
const EMPTY_CHART_DATA: LogEventCount[] = []

export const getChartData = (): LogEventCount[] => {
  return getState().search?.chart?.data || EMPTY_CHART_DATA
}

export const getChartInterval = (): TimeInterval | null => {
  return getState().search?.chart?.interval || null
}

export const isFetchingChartData = (): boolean => {
  const state = getState()
  return state.search?.chart?.isFetching || false
}
